<template>
  <router-view/>
</template>
<script>
// 屏蔽element-plus select 销毁后的getComputedStyle报错
const originGetComputedStyle = window.getComputedStyle
window.getComputedStyle = function(el, pseudo) {
  if(!el || !(el instanceof Element)){
    return {}
  }
  return originGetComputedStyle.call(this, el, pseudo)
}

// 解决ERROR ResizeObserver loop completed with undelivered notifications.的问题
const debounce = (fn, delay) => {
  let timer = null;
  return function () {
    let context = this;
    let args = arguments;
    clearTimeout(timer);
    timer = setTimeout(function () {
      fn.apply(context, args);
    }, delay);
  }
}


const _ResizeObserver = window.ResizeObserver;
window.ResizeObserver = class ResizeObserver extends _ResizeObserver {
  constructor(callback) {
    callback = debounce(callback, 16);
    super(callback);
  }
}
// END 解决ERROR ResizeObserver loop completed with undelivered notifications.的问题
</script>
<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: left;
  color: #2c3e50;
  font-size: 14px;
}

/*BEGIN 全局样式修改*/
.el-input .el-input__wrapper {
  background-color: #f7f7f7;
}
.el-select__wrapper{
  background-color: #f7f7f7 !important;
}
/* 自定义 Loading 遮罩层大小并居中 */
.el-loading-mask {
  width: 300px !important;
  height: 300px !important;
  left: 50% !important;
  top: 50% !important;
  transform: translate(-50%, -50%) !important;
  border-radius: 50%;
}
/* 自定义 Loading 图标颜色 - 强制覆盖 */
.el-loading-spinner * {
  stroke: #ffffff !important;
  fill: none !important;
}

.el-loading-spinner .circular,
.el-loading-spinner .path {
  stroke: #ffffff !important;
}

/* 自定义 Loading 文本颜色 */
.el-loading-text {
  color: #ffffff !important;
  font-size: 16px !important;
  margin-top: 15px !important;
}
/*END 全局样式修改*/

body{
  background-color: #f7f7f7;
}

.divPageTitle{
  width: auto; height: 40px; text-align: left; margin-left: 10px; margin-bottom: 30px;
}
.txtPageTitlePrimary{
  font-size: 24px; font-weight: bold;
}
.txtPageTitleSecond{
  font-size: 14px; color: #7a7a7a;
}
.divLRContainer{
  display: flex; flex-direction: row; width: 100%;
}
.divFlexLR{
  display: flex; align-items: center; justify-content: space-between;
}
.divFlexRow{
  display: flex; flex-direction: row; width: 100%; flex-wrap: wrap;
}
.divFlexColumn{
  display: flex; flex-direction: column; width: 100%;
}
.divLR{
  width: 50%;
}
.divAlignLR{
  display: flex; flex-direction: row; justify-content: space-between;
}
.divAlignTB{
  display: flex; flex-direction: column;
}
.divAlignVertical{
  display: flex;  align-items: center;
}
.elCardLeft {
  background: #fff;
  border-radius: 12px;
  padding: 20px;
  margin-bottom: 16px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);
  width: calc(100% - 60px);
  margin-left: 10px;
  text-align: left;
}
.elCardRight {
  background: #fff;
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);
  text-align: left;
}
.divTextTitle{
  font-size: 18px; font-weight: bold;
}
.divInputTitle{
  margin: 10px 0 5px 0; color: #7a7a7a;
}
.elBtnLong{
  width: 100%; margin-top: 30px;
}

.divCell{
  line-height: 40px;
}
.divCell30{
  line-height: 30px;
}

.iconPointer{
  cursor: pointer;
}
.iconPointer:hover{
  color: var(--el-color-primary);
}
.iconInBtn{
  margin-right: 5px;
}
.mt10{
  margin-top: 10px;
}
.ml10{
  margin-left: 10px;
}
.mr10{
  margin-right: 10px;
}
.mb10{
  margin-bottom: 10px;
}
.mb20{
  margin-bottom: 20px;
}
.btnUpload{
  position: absolute; right: 10px; bottom: 10px; border-radius: 50%; height: 50px; width: 50px; font-size: 24px; z-index: 9999;
}
.sysTitle{
  line-height: 50px; font-size: 24px; font-weight: bolder;
}
</style>
